import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { ProfileService } from 'src/app/core/services/profile.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { PrivateLibraryService } from 'src/app/core/services/private-library.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { CancelSubscriptionComponent } from '../../subscription-plans/cancel-subscription/cancel-subscription.component';
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { UploadSpaceModalComponent } from '../../wipod/upload-publication/upload-space-modal/upload-space-modal.component';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-share-modal',
  templateUrl: './share-modal.component.html',
  styleUrls: ['./share-modal.component.scss']
})
export class ShareModalComponent implements OnInit {
  imagePath = environment.url;
  isLoading: boolean = false;
  connections: any;
  selectedUserImage = 'assets/images/modals/default-user-profile-image.png';

  dropdownConnection = {
    singleSelection: true,
    enableSearchFilter: true,
    enableFilterSelectAll: false,
    classes: "myclass custom-class form-control",
    text: 'Please select connection',
    labelKey: "name",
    noDataLabel: "No connections found",
    searchBy: ['name']
  };

  shareForm: FormGroup;
  submitted: boolean = false;
  textAreaLength = 0;
  isSuppError = '';
  userData;
  isSuppDisableParent: boolean = false;
  @Input() public content_id;
  @Input() public content_type;
  @Input() public content;
  @Input() public content_collection;
  constructor(
    private activeModal: NgbActiveModal,
    private _profileService: ProfileService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private _privateLibraryService: PrivateLibraryService,
    private spinner: NgxSpinnerService,
    private _authService: AuthService
  ) { }

  ngOnInit() {
    this.userData = this._authService.getCurrentUser();
    if (this.content_type == 'document') {
      this.content_type = "Publication";
    } else if (this.content_type === 'special') {
      this.content_type = 'Package';
    } else if (this.content_type === 'normal') {
      this.content_type = 'Playlist';
    }
    this.shareForm = this.formBuilder.group({
      user: ['', Validators.required],
      notes: ['', [Validators.pattern(REGEX_PATTERNS.TEXT_AREA)]]
    });
    this.loadConnections();
  }

  closeDialog() {
    this.activeModal.dismiss();
  }

  loadConnections() {
    this._profileService.fetchConnections().subscribe(
      (response: any) => {
        if (response.success) {
          this.connections = response.data.connections;
          if (this.content_collection) {
            this.connections = this.connections.filter(c => c.user.user_account_type !== 'supplementary');
          }
          if (this.connections.length > 0) {
            this.connections.forEach(element => {
              if (element.user.name) {
                element.name = element.user.name;
              }
            });
          }
        }
        // this.spinner.hide();
        this.isLoading = false;
      }, (error: any) => {
        this.isLoading = false;
        // this.spinner.hide();
        // this._toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
      });
  }

  onSubmit() {
    this.submitted = true;
    if (!this.shareForm.valid) {
      return;
    }

    if (!this.content_id) {
      this.closeDialog();
      const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
      modalRef.componentInstance.message = "Content not found, Please try again.";
      return;
    }

    if (this.content) {
      this.shareContent();
    } else {
      this.shareCollection();
    }
  }

  shareContent() {
    let params = {
      content_id: this.content_id,
      recipient_id: this.shareForm.get('user').value[0].user.id
    }

    if (this.shareForm.get('notes').value) {
      params['notes'] = this.shareForm.get('notes').value.trim();
    }

    this.spinner.show();
    this._privateLibraryService.shareContent(params).subscribe(
      (response) => {
        this.spinner.hide();
        if (response.success) {
          const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modalRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.CONTENT_SHARE;
          this.closeDialog();
        }
        else if (response.status == 403) {
          if (response.data && response.data.current_user_id == response.data.content_user_id) {
            const modalRef = this.modalService.open(CancelSubscriptionComponent, { centered: true });
            modalRef.componentInstance.forStatus = 'share-content';
            modalRef.componentInstance.errorMessage = response.errors;
          }
          else {
            const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
            modalRef.componentInstance.message = response.errors;
          }
        }
        else if (response.errors) {
          const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
          modalRef.componentInstance.contentAccessError = response.errors;
          modalRef.componentInstance.isRedirectRequired = false;
        } else {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.CONTENT_SHARE;
        }
      }, (error) => {
        this.spinner.hide();
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.CONTENT_SHARE;
      });
  }

  shareCollection() {
    let params = {
      collection_id: this.content_id,
      recipient_id: this.shareForm.get('user').value[0].user.id
    }

    if (this.shareForm.get('notes').value) {
      params['notes'] = this.shareForm.get('notes').value.trim();
    }
    // if (this.userData.user.id != this.content_collection.displayable_user_details.id && !this.content_collection.is_creator_verified && this.content_collection.tokens > 0) {
    //   const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
    //   if (this.content_collection.collection_type === 'special') {
    //     modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.VERIFICATION_REJECTED_OWNER_COLLECTION_SHARE.replace('<collection>', 'package');
    //   } else {
    //     modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.VERIFICATION_REJECTED_OWNER_COLLECTION_SHARE.replace('<collection>', 'playlist');
    //   }
    //   return;
    // }

    this.spinner.show();
    this._privateLibraryService.shareCollection(params).subscribe(
      (response) => {
        this.spinner.hide();
        if (response.success) {
          const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          let message = LITERALS.AUTH.SUCCESS_MESSAGES.PLAYLIST_SHARE;
          if (this.content_type === 'Package') {
            message = LITERALS.AUTH.SUCCESS_MESSAGES.PACKAGE_SHARE;
          }
          modalRef.componentInstance.message = message;
          this.closeDialog();
        } else if (response.status === 403) {
          if (response.data && response.data.current_user_id === response.data.collection_user_id && this.content_type == 'Package') {
            const modalRef = this.modalService.open(CancelSubscriptionComponent, { centered: true });
            modalRef.componentInstance.forStatus = 'share-content';
            modalRef.componentInstance.errorMessage = response.errors;
          } else {
            const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
            modalRef.componentInstance.contentAccessError = response.errors;
            modalRef.componentInstance.isRedirectRequired = false;
          }
        }
        else if (response.errors) {
          const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
          modalRef.componentInstance.contentAccessError = response.errors;
          modalRef.componentInstance.isRedirectRequired = false;
        }
        else {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          let message = LITERALS.AUTH.ERROR_MESSAGES.PLAYLIST_SHARE;
          if (this.content_type === 'Package') {
            message = LITERALS.AUTH.ERROR_MESSAGES.PACKAGE_SHARE;
          }
          modalRef.componentInstance.message = message;
        }
      }, (error) => {
        this.spinner.hide();
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        let message = LITERALS.AUTH.ERROR_MESSAGES.PLAYLIST_SHARE;
        if (this.content_type === 'Package') {
          message = LITERALS.AUTH.ERROR_MESSAGES.PACKAGE_SHARE;
        }
        modalRef.componentInstance.message = message;
      });
  }

  onSelectConnection(item) {
    this.isSuppError = '';
    this.isSuppDisableParent = false;
    // this.shareForm.get('user').setValue([event]);
    if (item && !this.content_collection && this.content.adult_content && item.user.user_account_type == 'supplementary') {
      this.isSuppError = LITERALS.AUTH.ERROR_MESSAGES.SUPP_ADULT_CONTENT_SHARE;
    }
    if (item && item.supplementary_user_disable_status && item.user.user_account_type == 'supplementary') {
      if (item.user.parent_user_id == this.userData.user.id) {
        this.isSuppError = 't';
        this.isSuppDisableParent = true;
      } else {
        this.isSuppError = LITERALS.AUTH.ERROR_MESSAGES.SUPP_DISABLED_MESSAGE;
      }
    }
    if (item) {
      if (item.user.image) {
        this.selectedUserImage = this.imagePath + item.user.image;
      } else {
        this.selectedUserImage = 'assets/images/modals/default-user-profile-image.png';
      }
    }
    else {
      this.selectedUserImage = 'assets/images/modals/default-user-profile-image.png';
    }
  }
  OnConnectionDeselect(event) {
    // this.shareForm.get('user').setValue('');
    this.isSuppError = '';
    this.selectedUserImage = 'assets/images/modals/default-user-profile-image.png';
  }

  textAreaAdjust(event) {
    this.textAreaLength = event.target.value.length;
  }
}
